import { useEffect } from "react";

/**
 * Hook to reset expanded rows (or any state) when pagination changes.
 *
 * Usage:
 *   useResetExpandedOnPagination(() => setExpandedRows([]), [pageIndex, pageSize]);
 *
 * @param {Function} resetFn - function to call when dependencies change
 * @param {Array} deps - dependency array to trigger the reset
 */
const useResetExpandedOnPagination = (resetFn, deps = []) => {
  useEffect(() => {
    if (typeof resetFn === "function") resetFn();
  }, deps);
};

export default useResetExpandedOnPagination;
